<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="公司名称">
                <a-input v-model="queryParam.name" allow-clear placeholder="请输入公司名称" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="企业代码">
                <a-input v-model="queryParam.code" allow-clear placeholder="请输入企业代码" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="reload">查询</a-button>
                <a-button style="margin-left: 8px" @click="reload('reset')">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="addRow">新建</a-button>
        <a-button type="danger" icon="delete" @click="deleteRow">删除</a-button>
      </div>

      <s-table
        ref="table"
        size="default"
        :rowKey="record => record.id"
        :columns="columns"
        :data="loadData"
        :scroll="defaultScroll"
        showPagination="auto"
        :rowSelection="rowSelection"
        :totalCount="totalCount"
        :alert="true"
      >
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="editInfo(record)">编辑</a>
            <a-divider type="vertical"></a-divider>
            <a @click="lookInfo(record)">查看</a>
          </template>
        </span>
      </s-table>

      <company-create ref="companyCreate" @reload="reload" />
      <company-drawer ref="companyDrawer" />
      <company-delete ref="companyDelete" :selectedRows="selectedRows" @reload="reload('delete')" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { STable, Ellipsis } from '@/components'
import { companyQuery } from '@/api/company'
import companyCreate from './components/companyCreate'
import companyDrawer from './components/companyDrawer'
import companyDelete from './components/companyDelete'
import { columns } from './js/index'

export default {
  name: 'Agent',
  components: {
    STable,
    Ellipsis,
    companyCreate,
    companyDrawer,
    companyDelete
  },
  data() {
    return {
      columns,
      totalCount: 0,
      noticeTitle: '公司管理',
      queryParam: {},
      selectedRowKeys: [],
      selectedRows: [],
      loadData: parameter => {
        const params = this.paramFormat(parameter)
        Object.assign(params, this.queryParam)
        return companyQuery(params).then(res => {
          const result = this.resFormat(res, 'area')
          this.totalCount = result.totalCount
          return result
        })
      }
    }
  },
  watch: {},
  created() {},
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      }
    },
    serial() {
      return this.$store.state.env.serial
    },
    host() {
      return this.$store.state.oss.host
    }
  },
  methods: {
    reload(type = 'reload') {
      if (type === 'reset') this.queryParam = {}
      if (type === 'delete') this.selectedRows = []
      this.tableHome()
      this.$refs.table.refresh()
    },
    addRow() {
      this.$refs.companyCreate.showModal()
    },
    editInfo(record) {
      this.$refs.companyCreate.showModal(record)
    },
    lookInfo(record) {
      this.$refs.companyDrawer.showModal(record)
    },
    deleteRow() {
      const len = this.selectedRows.length
      if (len <= 0) {
        this.$message.warning('请选择要删除的项', 2)
      } else {
        this.$refs.companyDelete.showModal()
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
